// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_30xrv","wrapperOpen":"RrC9I _30xrv","nav":"_3SNVo","navOpen":"_3Yosj _3SNVo","heading":"_15utz","list":"wIlFu","link":"_2W2-y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation.css
// module id = 807
// module chunks = 0